import React from "react";
import { Box, Button, Stack, useTheme } from "@mui/material";
import MaterialModal from "../../../app/material-modal";
import AddCircleIcon from "@mui/icons-material/AddCircle";
// import scssVars from "../../../../../../../scss/variables.module.scss";
import ScoringQuestionTable from "./ScoringQuestionTable";
const buttonStyle = {
  // color: scssVars.mainIconColor,
  // borderColor: scssVars.borderGrey,
  width: 190,
  marginBottom: 1,
  backgroundColor: "white",
  ":hover": {
    // color: scssVars.mainButtonHighlight,
  },
};

export function ScoringQuestionsModal() {
  const [open, setOpen] = React.useState(false);
  const muiTheme = useTheme();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ width: "100%" }}>
      <Button variant="contained" fullWidth onClick={handleOpen} disabled>
        Edit Scoring Questions
      </Button>
      <MaterialModal
        open={open}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minHeight: "500px",
              minWidth: "800px",
              ".MuiDialogContent-root": {
                overflow: "auto",
              },
            },
          },
        }}
        title=" Team Scoring Questions"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <Stack
            direction="row"
            gap={3}
            sx={{
              width: "300px",
              height: "auto",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Box sx={{ flexBasis: "40%" }}>
              <Button variant="outlined" sx={buttonStyle} onClick={handleOpen}>
                <AddCircleIcon
                  sx={{
                    marginRight: "4px",
                    fontSize: "24px",
                    color: muiTheme.palette.primary.main,
                    opacity: 1,
                  }}
                />
                Add Questions
              </Button>
            </Box>
            <Box>
              <Button variant="outlined" sx={buttonStyle} onClick={handleOpen}>
                <AddCircleIcon
                  sx={{
                    marginRight: "4px",
                    fontSize: "24px",
                    color: muiTheme.palette.primary.main,
                    opacity: 1,
                  }}
                />
                Add New Questions
              </Button>
            </Box>
          </Stack>
          <ScoringQuestionTable />
        </Box>
      </MaterialModal>
    </Box>
  );
}
